import { api } from '../client'
import { ADMIN_ENDPOINTS, AdminResource } from '../config'

export type AdminRecord = Record<string, unknown> & { _id: string }

/**
 * Generic CRUD client for the Anointed Kids content-management endpoints
 * (`/api/v1/admin/<resource>`). Read endpoints are open to any authenticated
 * user; writes require the CONTENT_MANAGE permission (or sudo).
 */
export const AdminService = {
    list: (
        resource: AdminResource,
        params: Record<string, string | number | undefined> = {}
    ) => api.get<AdminRecord[]>(ADMIN_ENDPOINTS.LIST(resource, params)),

    get: (resource: AdminResource, id: string) =>
        api.get<AdminRecord>(ADMIN_ENDPOINTS.BY_ID(resource, id)),

    create: (resource: AdminResource, body: Record<string, unknown>) =>
        api.post<AdminRecord>(ADMIN_ENDPOINTS.CREATE(resource), body),

    update: (resource: AdminResource, id: string, body: Record<string, unknown>) =>
        api.patch<AdminRecord>(ADMIN_ENDPOINTS.UPDATE(resource, id), body),

    remove: (resource: AdminResource, id: string) =>
        api.delete<void>(ADMIN_ENDPOINTS.DELETE(resource, id))
}
